import React, { useContext, useEffect } from 'react';

import Paper from '@material-ui/core/Paper';
import moment from 'moment';

import { GlobalContext } from '../../../store';
import { IEventItem } from '../../../store/player/events/store';

import List from '../../../components/Lists/List/List';
import NextEvent from '../../../components/NextEvent/NextEvent';
import EventToday from '../ClubHome/EventToday/EventToday';
import { PlayerSeasonSelector } from '../Common/Components/PlayerSeasonSelector/PlayerSeasonSelector';
import { usePlayerSeasons } from '../Common/Hooks/usePlayerSeasons.hook';
import { ClubEventToday } from '../Home/ClubEventToday/ClubEventToday';
import EventContent from '../../../components/NextEvent/Components/EventContent/EventContent';
import { today } from '../../../Utils/today';
import { filters } from './Utils/filters';
import { sorting } from './Utils/sorting';

interface IProps {
  clubId: string;
  seasonId: string;
}

export const ClubEvents = (props: IProps) => {
  const { seasonId, clubId } = props;

  const {
    actions: {
      seasons: { get: getSeasons },
      events: { getAllClubEvents }
    },
    events,
    seasons
  } = useContext(GlobalContext);

  const [clubSeasons, currentSeason] = usePlayerSeasons({
    clubId,
    getSeasons,
    seasonId,
    seasons
  });

  const allEvents: IEventItem[] = Object.values(events.all)
    .filter(event => {
      const isAnEventFromThisClub = !!event.club && event.club.id === Number(clubId);
      const isAnEventFromThisSeason =
        !!event.season && currentSeason && event.season.id === currentSeason.id;

      return seasonId === 'All'
        ? isAnEventFromThisClub
        : isAnEventFromThisClub && isAnEventFromThisSeason;
    })
    .sort((a, b) => (a.start > b.start ? 1 : -1));

  const nextEvent = allEvents.find(
    ({ start, enrollment: { status } }) => moment(start).isAfter(today) && status === 'active'
  );

  useEffect(() => {
    getAllClubEvents(clubId).catch();
  }, [clubId]);

  return (
    <div>
      <div className="home club-home club-events">
        <Paper className="paper-full-width">
          <PlayerSeasonSelector
            clubSeasons={clubSeasons}
            section="events"
            clubId={clubId}
            currentSeason={currentSeason}
          />

          {currentSeason && (
            <>
              <EventToday clubId={Number(clubId)} currentSeason={currentSeason} />

              <ClubEventToday
                currentSeason={currentSeason}
                classNames="nomargintop"
                clubId={Number(clubId)}
              />
            </>
          )}

          <NextEvent item={nextEvent} />

          <List
            title="ALL EVENTS"
            items={allEvents}
            renderItem={EventContent}
            filters={filters}
            sorting={sorting}
          />
        </Paper>
      </div>
    </div>
  );
};

export default ClubEvents;
